export const action_colors = (dark) => ({
    active: dark ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.54)',
});
